import { LoaderCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Twitter } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

interface RepliesLoadingDialogProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const RepliesLoadingDialog: React.FC<RepliesLoadingDialogProps> = ({
  isOpen,
  message,
  onClose,
}) => {
  return (
    <Dialog open={isOpen}>
      <DialogContent className="max-w-md">
        <div className="flex flex-col items-center">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <LoaderCircle className="h-12 w-12 animate-spin absolute" />
            <div className="h-24 w-24 rounded-full border-4 border-muted-foreground/20 animate-pulse absolute"></div>
            <Twitter className="h-6 w-6 text-blue-500 absolute" />
          </div>
          <p className="mt-6 text-center font-medium">{message}</p>
          <p className="mt-2 text-center text-sm text-muted-foreground">
            This process is running in the background.
          </p>
          <div className="ml-auto mt-8">
            <Button variant="outline" onClick={onClose}>
              Continue in Background
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RepliesLoadingDialog;
